'use client';
const storage = new Map();
const InMemoryCache = {
    clientOnly: false,
    set: (key, value)=>storage.set(key, value),
    get: (key)=>{
        var _storage_get;
        return (_storage_get = storage.get(key)) != null ? _storage_get : null;
    }
};

export { InMemoryCache };
//# sourceMappingURL=in-memory-cache.js.map
